
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("4ybgQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $04xaX = parcelRequire("04xaX");


var $iDrrr = parcelRequire("iDrrr");


var $31fUM = parcelRequire("31fUM");

const $838e026edc294e9f$var$_default_1 = /*#__PURE__*/ (0, $cozmU.memo)(function MentionItem(props) {
    const { eventHandlers: eventHandlers, id: id, providers: providers, text: text, accessLevel: accessLevel, localId: localId, userType: userType } = props;
    const inlineAnnotationProps = (0, $31fUM.useInlineAnnotationProps)(props);
    if ((0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", inlineAnnotationProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04xaX.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        providers: providers,
        localId: localId,
        userType: userType,
        eventHandlers: eventHandlers && eventHandlers.mention
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $04xaX.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        providers: providers,
        localId: localId,
        userType: userType,
        eventHandlers: eventHandlers && eventHandlers.mention
    });
});
var $838e026edc294e9f$export$2e2bcd8739ae039 = $838e026edc294e9f$var$_default_1;
module.exports["default"] = $838e026edc294e9f$export$2e2bcd8739ae039;

});

parcelRegister("04xaX", function(module, exports) {
/* eslint-disable @repo/internal/react/no-class-components */ 
var $cozmU = parcelRequire("cozmU");


var $ieeJu = parcelRequire("ieeJu");


var $eNbr2 = parcelRequire("eNbr2");

var $794I6 = parcelRequire("794I6");


var $d4eUy = parcelRequire("d4eUy");

const $3ca1b04bd37e35d3$var$MENTION_PROVIDERS = [
    'mentionProvider',
    'profilecardProvider'
];
class $3ca1b04bd37e35d3$export$2e2bcd8739ae039 extends (0, $cozmU.PureComponent) {
    componentWillUnmount() {
        if (!this.props.providers) // new ProviderFactory is created if no `providers` has been set
        // in this case when component is unmounted it's safe to destroy this providerFactory
        this.providerFactory.destroy();
    }
    render() {
        const providers = (0, $ieeJu.expValEquals)('platform_editor_perf_lint_cleanup', 'isEnabled', true) ? $3ca1b04bd37e35d3$var$MENTION_PROVIDERS : [
            'mentionProvider',
            'profilecardProvider'
        ];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $794I6.WithProviders), {
            providers: providers,
            providerFactory: this.providerFactory,
            renderNode: this.renderWithProvider
        });
    }
    constructor(props){
        super(props);
        this.providerFactory = void 0;
        this.renderWithProvider = (providers)=>{
            const { accessLevel: accessLevel, eventHandlers: eventHandlers, id: id, text: text, localId: localId, userType: userType, isDisabled: isDisabled, disabledTooltip: disabledTooltip } = this.props;
            const { mentionProvider: mentionProvider, profilecardProvider: profilecardProvider } = providers;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d4eUy.MentionWithProviders), {
                id: id,
                text: text,
                accessLevel: accessLevel,
                localId: localId,
                userType: userType,
                isDisabled: isDisabled,
                disabledTooltip: disabledTooltip,
                eventHandlers: eventHandlers,
                mentionProvider: mentionProvider,
                profilecardProvider: profilecardProvider
            });
        };
        this.providerFactory = props.providers || new (0, $eNbr2.default)();
    }
}
module.exports["default"] = $3ca1b04bd37e35d3$export$2e2bcd8739ae039;

});

parcelRegister("d4eUy", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $5zCi6 = parcelRequire("5zCi6");


var $Hhhdz = parcelRequire("Hhhdz");

const $379fc97538bbbbaa$var$GENERIC_USER_IDS = [
    'HipChat',
    'all',
    'here'
];
const $379fc97538bbbbaa$export$cd21803c89efe790 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).memo((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(29);
    const { accessLevel: accessLevel, disabledTooltip: disabledTooltip, eventHandlers: eventHandlers, id: id, isDisabled: isDisabled, mentionProvider: mentionProvider, profilecardProvider: profilecardProviderResolver, text: text, localId: localId, userType: userType } = t0;
    const [profilecardProvider, setProfilecardProvider] = (0, $cozmU.useState)(null);
    const mountedRef = (0, $cozmU.useRef)(true);
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            mountedRef.current = true;
            return ()=>{
                mountedRef.current = false;
            };
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $cozmU.useLayoutEffect)(t1, t2);
    let t3;
    let t4;
    if ($[2] !== profilecardProviderResolver) {
        t3 = ()=>{
            profilecardProviderResolver?.then((result)=>{
                if (mountedRef.current) setProfilecardProvider(result);
            }).catch(()=>{
                if (mountedRef.current) setProfilecardProvider(null);
            });
        };
        t4 = [
            profilecardProviderResolver
        ];
        $[2] = profilecardProviderResolver;
        $[3] = t3;
        $[4] = t4;
    } else {
        t3 = $[3];
        t4 = $[4];
    }
    (0, $cozmU.useLayoutEffect)(t3, t4);
    const MentionComponent = profilecardProvider && profilecardProviderResolver && $379fc97538bbbbaa$var$GENERIC_USER_IDS.indexOf(id) === -1 ? (0, $Hhhdz.default) : (0, $5zCi6.default);
    const ssrPlaceholderId = `mention-${id}`;
    if (isDisabled) {
        const t5 = eventHandlers?.onClick;
        const t6 = eventHandlers?.onMouseEnter;
        const t7 = eventHandlers?.onMouseLeave;
        let t8;
        if ($[5] !== accessLevel || $[6] !== disabledTooltip || $[7] !== id || $[8] !== localId || $[9] !== mentionProvider || $[10] !== ssrPlaceholderId || $[11] !== t5 || $[12] !== t6 || $[13] !== t7 || $[14] !== text) {
            t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5zCi6.default), {
                id: id,
                text: text,
                accessLevel: accessLevel,
                localId: localId,
                mentionProvider: mentionProvider,
                isDisabled: true,
                disabledTooltip: disabledTooltip,
                onClick: t5,
                onMouseEnter: t6,
                onMouseLeave: t7,
                ssrPlaceholderId: ssrPlaceholderId
            });
            $[5] = accessLevel;
            $[6] = disabledTooltip;
            $[7] = id;
            $[8] = localId;
            $[9] = mentionProvider;
            $[10] = ssrPlaceholderId;
            $[11] = t5;
            $[12] = t6;
            $[13] = t7;
            $[14] = text;
            $[15] = t8;
        } else t8 = $[15];
        return t8;
    }
    const t5 = eventHandlers?.onClick;
    const t6 = eventHandlers?.onMouseEnter;
    const t7 = eventHandlers?.onMouseLeave;
    let t8;
    if ($[16] !== MentionComponent || $[17] !== accessLevel || $[18] !== id || $[19] !== localId || $[20] !== mentionProvider || $[21] !== profilecardProvider || $[22] !== ssrPlaceholderId || $[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== text || $[27] !== userType) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(MentionComponent, {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            userType: userType,
            mentionProvider: mentionProvider,
            profilecardProvider: profilecardProvider,
            onClick: t5,
            onMouseEnter: t6,
            onMouseLeave: t7,
            ssrPlaceholderId: ssrPlaceholderId
        });
        $[16] = MentionComponent;
        $[17] = accessLevel;
        $[18] = id;
        $[19] = localId;
        $[20] = mentionProvider;
        $[21] = profilecardProvider;
        $[22] = ssrPlaceholderId;
        $[23] = t5;
        $[24] = t6;
        $[25] = t7;
        $[26] = text;
        $[27] = userType;
        $[28] = t8;
    } else t8 = $[28];
    return t8;
} : ({ accessLevel: accessLevel, disabledTooltip: disabledTooltip, eventHandlers: eventHandlers, id: id, isDisabled: isDisabled, mentionProvider: mentionProvider, profilecardProvider: profilecardProviderResolver, text: text, localId: localId, userType: userType })=>{
    const [profilecardProvider, setProfilecardProvider] = (0, $cozmU.useState)(null);
    const mountedRef = (0, $cozmU.useRef)(true);
    (0, $cozmU.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $cozmU.useLayoutEffect)(()=>{
        // We are not using async/await here to avoid having an intermediate Promise
        // introduced by the transpiler.
        // This will allow consumer to use a SynchronousPromise.resolve and avoid useless
        // rerendering
        profilecardProviderResolver?.then((result)=>{
            if (mountedRef.current) setProfilecardProvider(result);
        }).catch(()=>{
            if (mountedRef.current) setProfilecardProvider(null);
        });
    }, [
        profilecardProviderResolver
    ]);
    const MentionComponent = profilecardProvider && profilecardProviderResolver && $379fc97538bbbbaa$var$GENERIC_USER_IDS.indexOf(id) === -1 ? (0, $Hhhdz.default) : (0, $5zCi6.default);
    const ssrPlaceholderId = `mention-${id}`;
    // A disabled mention is non-interactive, so it bypasses the profile-card
    // wrapper and renders the disabled resourced mention directly.
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5zCi6.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        mentionProvider: mentionProvider,
        isDisabled: true,
        disabledTooltip: disabledTooltip,
        onClick: eventHandlers?.onClick,
        onMouseEnter: eventHandlers?.onMouseEnter,
        onMouseLeave: eventHandlers?.onMouseLeave,
        ssrPlaceholderId: ssrPlaceholderId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(MentionComponent, {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        userType: userType,
        mentionProvider: mentionProvider,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        profilecardProvider: profilecardProvider,
        onClick: eventHandlers?.onClick,
        onMouseEnter: eventHandlers?.onMouseEnter,
        onMouseLeave: eventHandlers?.onMouseLeave,
        ssrPlaceholderId: ssrPlaceholderId
    });
});
module.exports["MentionWithProviders"] = $379fc97538bbbbaa$export$cd21803c89efe790;

});

parcelRegister("5zCi6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bijHC = parcelRequire("bijHC");


var $caelp = parcelRequire("caelp");


var $12QCz = parcelRequire("12QCz");


var $2SUNK = parcelRequire("2SUNK");

class $9a3220735be5ff34$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).PureComponent {
    componentDidMount() {
        this.handleMentionProvider(this.props);
        this._isMounted = true;
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { props: props } = this;
        if (props.id !== nextProps.id || props.mentionProvider !== nextProps.mentionProvider) this.handleMentionProvider(nextProps);
    }
    setStateSafely(newState) {
        if (!this._isMounted) {
            (0, $2SUNK.default)('[ResourcedMention]: cannot setState when component is unmounted.');
            return;
        }
        this.setState(newState);
    }
    processName(name) {
        let mentionName;
        switch(name.status){
            case (0, $caelp.MentionNameStatus).OK:
                mentionName = name.name || '';
                break;
            case (0, $caelp.MentionNameStatus).SERVICE_ERROR:
            case (0, $caelp.MentionNameStatus).UNKNOWN:
            default:
                mentionName = (0, $12QCz.UNKNOWN_USER_ID);
                break;
        }
        return `@${mentionName}`;
    }
    render() {
        const { props: props, state: state } = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $12QCz.default), {
            id: props.id,
            text: props.text || state.resolvedMentionName || '',
            isHighlighted: state.isHighlighted,
            isDisabled: props.isDisabled,
            disabledTooltip: props.disabledTooltip,
            accessLevel: props.accessLevel,
            localId: props.localId,
            onClick: props.onClick,
            onMouseEnter: props.onMouseEnter,
            onMouseLeave: props.onMouseLeave,
            ssrPlaceholderId: props.ssrPlaceholderId
        });
    }
    constructor(_props){
        super(_props);
        this._isMounted = void 0;
        this.handleMentionProvider = (props)=>{
            const { id: id, mentionProvider: mentionProvider, text: text } = props;
            if (mentionProvider) mentionProvider.then((provider)=>{
                const newState = {
                    isHighlighted: provider.shouldHighlightMention({
                        id: id
                    })
                };
                if (!text && (0, $bijHC.isResolvingMentionProvider)(provider)) {
                    const nameDetail = provider.resolveMentionName(id);
                    if ((0, $caelp.isPromise)(nameDetail)) nameDetail.then((nameDetailResult)=>{
                        this.setStateSafely({
                            resolvedMentionName: this.processName(nameDetailResult)
                        });
                    });
                    else newState.resolvedMentionName = this.processName(nameDetail);
                }
                this.setStateSafely(newState);
            }).catch(()=>{
                this.setStateSafely({
                    isHighlighted: false
                });
            });
            else this.setStateSafely({
                isHighlighted: false
            });
        };
        this._isMounted = false;
        this.state = {
            isHighlighted: false
        };
    }
}
module.exports["default"] = $9a3220735be5ff34$export$2e2bcd8739ae039;

});

parcelRegister("Hhhdz", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $4wH3g = parcelRequire("4wH3g");


var $5zCi6 = parcelRequire("5zCi6");


var $iDrrr = parcelRequire("iDrrr");


var $l8Rhq = parcelRequire("l8Rhq");


var $22Zs7 = parcelRequire("22Zs7");


var $eW61a = parcelRequire("eW61a");


var $ieeJu = parcelRequire("ieeJu");


// Lazy-loaded so the agent profile card chunk (and its `@atlaskit/rovo-agent-components`
// dependency) stays off the critical path — it is only fetched when an agent mention
// (`userType === 'APP'`) actually renders, never for person mentions.
// Uses react-loadable to match editor-common's code-splitting factory (see src/icons/index.ts).
const $e56bc9dce22ad0d3$var$AgentProfileCardTrigger = (0, (/*@__PURE__*/$parcel$interopDefault($4wH3g)))({
    __loadable_id__: "KoACG",
    name: "AgentProfileCardTrigger",
    loader: ()=>(parcelRequire("8WrgS")).then((mod)=>mod.AgentProfileCardTrigger),
    loading: ()=>null
});
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $e56bc9dce22ad0d3$var$AT_PREFIX_REGEX = /^@/;
/**
 * Renders a mention chip wrapped in the appropriate profile card trigger.
 * 1. Agent mentions (`userType === 'APP'`, behind `rovo_chat_agent_selection`) open the Rovo agent profile card on click.
 * 2. Otherwise renders the person profile card (either via the provider's `renderUserMentionCard`/link fallback or the default user `ProfileCardTrigger`).
 */ const $e56bc9dce22ad0d3$var$MentionWithProfileCard = (0, $gtMdU.isReactCompilerActivePlatform)() ? function MentionWithProfileCard(t0) {
    const $ = (0, $bDgLe.c)(46);
    const { autoFocus: autoFocus, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, localId: localId, ssrPlaceholderId: ssrPlaceholderId, userType: userType } = t0;
    const { cloudId: cloudId, renderUserMentionCard: renderUserMentionCard, resourceClient: resourceClient } = profilecardProvider;
    let t1;
    if ($[0] !== accessLevel || $[1] !== id || $[2] !== profilecardProvider || $[3] !== text) {
        t1 = profilecardProvider.getActions(id, text, accessLevel);
        $[0] = accessLevel;
        $[1] = id;
        $[2] = profilecardProvider;
        $[3] = text;
        $[4] = t1;
    } else t1 = $[4];
    const actions = t1;
    let t2;
    if ($[5] !== accessLevel || $[6] !== id || $[7] !== localId || $[8] !== mentionProvider || $[9] !== onClick || $[10] !== onMouseEnter || $[11] !== onMouseLeave || $[12] !== ssrPlaceholderId || $[13] !== text) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5zCi6.default), {
            id: id,
            text: text,
            accessLevel: accessLevel,
            localId: localId,
            mentionProvider: mentionProvider,
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            ssrPlaceholderId: ssrPlaceholderId
        });
        $[5] = accessLevel;
        $[6] = id;
        $[7] = localId;
        $[8] = mentionProvider;
        $[9] = onClick;
        $[10] = onMouseEnter;
        $[11] = onMouseLeave;
        $[12] = ssrPlaceholderId;
        $[13] = text;
        $[14] = t2;
    } else t2 = $[14];
    const mention = t2;
    if (userType === "APP" && cloudId && (0, $iDrrr.fg)("rovo_chat_agent_selection")) {
        let t3;
        if ($[15] !== cloudId || $[16] !== id || $[17] !== mention || $[18] !== resourceClient) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e56bc9dce22ad0d3$var$AgentProfileCardTrigger, {
                agentId: id,
                cloudId: cloudId,
                resourceClient: resourceClient,
                trigger: "click"
            }, mention);
            $[15] = cloudId;
            $[16] = id;
            $[17] = mention;
            $[18] = resourceClient;
            $[19] = t3;
        } else t3 = $[19];
        return t3;
    }
    if ((0, $iDrrr.fg)("people-teams_migrate-user-profile-card")) {
        if (renderUserMentionCard) {
            let t3;
            if ($[20] !== cloudId || $[21] !== id || $[22] !== mention || $[23] !== renderUserMentionCard) {
                t3 = renderUserMentionCard({
                    userId: id,
                    cloudId: cloudId,
                    children: mention
                });
                $[20] = cloudId;
                $[21] = id;
                $[22] = mention;
                $[23] = renderUserMentionCard;
                $[24] = t3;
            } else t3 = $[24];
            let t4;
            if ($[25] !== t3) {
                t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t3);
                $[25] = t3;
                $[26] = t4;
            } else t4 = $[26];
            return t4;
        }
        let t3;
        if ($[27] !== cloudId || $[28] !== id) {
            t3 = (0, $eW61a.navigateToTeamsApp)({
                type: "USER",
                payload: {
                    userId: id
                },
                cloudId: cloudId
            });
            $[27] = cloudId;
            $[28] = id;
            $[29] = t3;
        } else t3 = $[29];
        const { href: href, target: target } = t3;
        let t4;
        if ($[30] !== href || $[31] !== mention || $[32] !== target) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
                href: href,
                target: target,
                rel: "noopener noreferrer",
                testId: "mention-with-profilecard-link-fallback"
            }, mention);
            $[30] = href;
            $[31] = mention;
            $[32] = target;
            $[33] = t4;
        } else t4 = $[33];
        return t4;
    }
    let t3;
    if ($[34] !== text) {
        t3 = text.replace($e56bc9dce22ad0d3$var$AT_PREFIX_REGEX, "");
        $[34] = text;
        $[35] = t3;
    } else t3 = $[35];
    let t4;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (0, $ieeJu.expValEquals)("editor_a11y_7152_profile_card_tab_order", "isEnabled", true);
        $[36] = t4;
    } else t4 = $[36];
    let t5;
    if ($[37] !== actions || $[38] !== autoFocus || $[39] !== cloudId || $[40] !== id || $[41] !== mention || $[42] !== resourceClient || $[43] !== ssrPlaceholderId || $[44] !== t3) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22Zs7.default), {
            autoFocus: autoFocus,
            cloudId: cloudId,
            userId: id,
            resourceClient: resourceClient,
            actions: actions,
            trigger: "click",
            position: "bottom-end",
            testId: "mention-with-profilecard-trigger",
            ariaLabel: t3,
            ssrPlaceholderId: ssrPlaceholderId,
            isRenderedInPortal: t4
        }, mention);
        $[37] = actions;
        $[38] = autoFocus;
        $[39] = cloudId;
        $[40] = id;
        $[41] = mention;
        $[42] = resourceClient;
        $[43] = ssrPlaceholderId;
        $[44] = t3;
        $[45] = t5;
    } else t5 = $[45];
    return t5;
} : function MentionWithProfileCard({ autoFocus: autoFocus, id: id, text: text, accessLevel: accessLevel, mentionProvider: mentionProvider, profilecardProvider: profilecardProvider, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, localId: localId, ssrPlaceholderId: ssrPlaceholderId, userType: userType }) {
    const { cloudId: cloudId, renderUserMentionCard: renderUserMentionCard, resourceClient: resourceClient } = profilecardProvider;
    const actions = (0, $cozmU.useMemo)(()=>profilecardProvider.getActions(id, text, accessLevel), [
        accessLevel,
        id,
        profilecardProvider,
        text
    ]);
    const mention = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5zCi6.default), {
        id: id,
        text: text,
        accessLevel: accessLevel,
        localId: localId,
        mentionProvider: mentionProvider,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        ssrPlaceholderId: ssrPlaceholderId
    });
    // Agent mentions (userType 'APP') open the Rovo agent profile card on click.
    if (userType === 'APP' && cloudId && (0, $iDrrr.fg)('rovo_chat_agent_selection')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e56bc9dce22ad0d3$var$AgentProfileCardTrigger, {
        agentId: id,
        cloudId: cloudId,
        resourceClient: resourceClient,
        trigger: "click"
    }, mention);
    if ((0, $iDrrr.fg)('people-teams_migrate-user-profile-card')) {
        if (renderUserMentionCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, renderUserMentionCard({
            userId: id,
            cloudId: cloudId,
            children: mention
        }));
        const { href: href, target: target } = (0, $eW61a.navigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: id
            },
            cloudId: cloudId
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.default), {
            href: href,
            target: target,
            rel: "noopener noreferrer",
            testId: "mention-with-profilecard-link-fallback"
        }, mention);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22Zs7.default), {
        autoFocus: autoFocus,
        cloudId: cloudId,
        userId: id,
        resourceClient: resourceClient,
        actions: actions,
        trigger: "click",
        position: "bottom-end",
        testId: "mention-with-profilecard-trigger",
        ariaLabel: text.replace($e56bc9dce22ad0d3$var$AT_PREFIX_REGEX, ''),
        ssrPlaceholderId: ssrPlaceholderId,
        isRenderedInPortal: (0, $ieeJu.expValEquals)('editor_a11y_7152_profile_card_tab_order', 'isEnabled', true)
    }, mention);
};
var $e56bc9dce22ad0d3$export$2e2bcd8739ae039 = $e56bc9dce22ad0d3$var$MentionWithProfileCard;
module.exports["default"] = $e56bc9dce22ad0d3$export$2e2bcd8739ae039;

});

parcelRegister("8WrgS", function(module, exports) {

let $6828e500cc16d59b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6828e500cc16d59b$var$load("cyTuQ").then(()=>parcelRequire('eKpjD'));

});

parcelRegister("31fUM", function(module, exports) {
/* eslint-disable jsdoc/require-jsdoc */ 
var $iDrrr = parcelRequire("iDrrr");


var $hZmcT = parcelRequire("hZmcT");

function $1e80a135c5761dad$export$11564cda945bb3c9(props) {
    const { selectionDraftDocumentPosition: draftPosition } = (0, $hZmcT.useAnnotationRangeState)();
    if (!(0, $iDrrr.fg)('editor_inline_comments_on_inline_nodes')) return {};
    if (!props.dataAttributes) // the inlineCard component is currently used by the block card, embed card and card error boundary components
    // when used via these components, no dataAttributes are passed (and we don't want it setup for inline comments)
    return {};
    const inlineCardPosition = props.dataAttributes['data-renderer-start-pos'] - 1;
    const hasDraft = draftPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.from <= inlineCardPosition && // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    draftPosition?.to >= inlineCardPosition + 1;
    if (hasDraft) return {
        'data-renderer-mark': true,
        'data-annotation-draft-mark': true,
        'data-annotation-inline-node': true,
        'data-renderer-start-pos': inlineCardPosition
    };
    return {
        'data-annotation-inline-node': true,
        'data-annotation-mark': true,
        'data-renderer-start-pos': inlineCardPosition
    };
}
module.exports["useInlineAnnotationProps"] = $1e80a135c5761dad$export$11564cda945bb3c9;

});

parcelRegister("21cx5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $j1Rvl = parcelRequire("j1Rvl");

const $f497c875f65a609f$var$EMPTY = {};
const $f497c875f65a609f$var$useI18n = (0, $gtMdU.isReactCompilerActivePlatform)() ? (locale)=>{
    const $ = (0, $bDgLe.c)(3);
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    let t0;
    let t1;
    if ($[0] !== locale) {
        t0 = ()=>{
            let aborted = false;
            setMessages($f497c875f65a609f$var$EMPTY);
            (0, $j1Rvl.getMessagesForLocale)(locale).then((messages_0)=>{
                if (!aborted) setMessages(messages_0);
            }).catch($f497c875f65a609f$var$_temp);
            return ()=>{
                aborted = true;
            };
        };
        t1 = [
            locale
        ];
        $[0] = locale;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(t0, t1);
    return messages;
} : (locale)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState($f497c875f65a609f$var$EMPTY);
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages($f497c875f65a609f$var$EMPTY);
        (0, $j1Rvl.getMessagesForLocale)(locale).then((messages_0)=>{
            if (!aborted) setMessages(messages_0);
        }).catch((error)=>{
            // eslint-disable-next-line no-console
            console.error(error);
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale
    ]);
    return messages;
};
const $f497c875f65a609f$var$MessagesIntlProvider = (0, $gtMdU.isReactCompilerActivePlatform)() ? (props)=>{
    const $ = (0, $bDgLe.c)(4);
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    let t0;
    if ($[0] !== children || $[1] !== intl || $[2] !== messages) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
            ...intl,
            messages: messages
        }, children);
        $[0] = children;
        $[1] = intl;
        $[2] = messages;
        $[3] = t0;
    } else t0 = $[3];
    return t0;
} : (props)=>{
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $f497c875f65a609f$var$useI18n(intl.locale);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $f497c875f65a609f$export$2e2bcd8739ae039 = $f497c875f65a609f$var$MessagesIntlProvider;
function $f497c875f65a609f$var$_temp(error) {
    console.error(error);
}
module.exports["default"] = $f497c875f65a609f$export$2e2bcd8739ae039;

});

parcelRegister("j1Rvl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $92AHJ = parcelRequire("92AHJ");

const $878ccfcc8552aaa6$export$392a0c6a82ab0e50 = (messageDescriptor)=>({ values: values, children: children })=>{
        const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
        const message = formatMessage(messageDescriptor, values);
        if (typeof children === 'function') return children(message);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            values: values,
            ...messageDescriptor
        });
    };
const $878ccfcc8552aaa6$export$98e06fe7a6174253 = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).unknownUserError);
const $878ccfcc8552aaa6$export$58bd5a2057b6b855 = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).noAccessWarning);
const $878ccfcc8552aaa6$export$da9f8ce14593162f = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).noAccessLabel);
const $878ccfcc8552aaa6$export$4a258ffee7316766 = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).defaultHeadline);
const $878ccfcc8552aaa6$export$702321a50d74536e = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).defaultAdvisedAction);
const $878ccfcc8552aaa6$export$ed7f16088a93ae9d = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).loginAgain);
const $878ccfcc8552aaa6$export$3ab158df56460d1c = $878ccfcc8552aaa6$export$392a0c6a82ab0e50((0, $92AHJ.messages).differentText);































const $878ccfcc8552aaa6$export$d0a3169680473b6c = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("d4YSb")).then((mod)=>mod.default);
        case 'da':
            return (parcelRequire("2cdNr")).then((mod)=>mod.default);
        case 'de':
            return (parcelRequire("7l9dA")).then((mod)=>mod.default);
        case 'en':
            return (parcelRequire("gpL0n")).then((mod)=>mod.default);
        case 'en_GB':
            return (parcelRequire("bjfkf")).then((mod)=>mod.default);
        case 'en_ZZ':
            return (parcelRequire("kLZmK")).then((mod)=>mod.default);
        case 'es':
            return (parcelRequire("5a0Qd")).then((mod)=>mod.default);
        case 'et':
            return (parcelRequire("1KQVk")).then((mod)=>mod.default);
        case 'fi':
            return (parcelRequire("bqpxF")).then((mod)=>mod.default);
        case 'fr':
            return (parcelRequire("l7Ke1")).then((mod)=>mod.default);
        case 'hu':
            return (parcelRequire("dGQYY")).then((mod)=>mod.default);
        case 'is':
            return (parcelRequire("1lX2v")).then((mod)=>mod.default);
        case 'it':
            return (parcelRequire("freW0")).then((mod)=>mod.default);
        case 'ja':
            return (parcelRequire("3OPCa")).then((mod)=>mod.default);
        case 'ko':
            return (parcelRequire("bwEbt")).then((mod)=>mod.default);
        case 'nb':
            return (parcelRequire("5at1X")).then((mod)=>mod.default);
        case 'nl':
            return (parcelRequire("eWJ7x")).then((mod)=>mod.default);
        case 'pl':
            return (parcelRequire("2FTTE")).then((mod)=>mod.default);
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("bq5Mn")).then((mod)=>mod.default);
        case 'pt_PT':
        case 'pt-PT':
            return (parcelRequire("6paIk")).then((mod)=>mod.default);
        case 'ro':
            return (parcelRequire("I5fxG")).then((mod)=>mod.default);
        case 'ru':
            return (parcelRequire("1FesQ")).then((mod)=>mod.default);
        case 'sk':
            return (parcelRequire("cx1wp")).then((mod)=>mod.default);
        case 'sv':
            return (parcelRequire("jK1Cf")).then((mod)=>mod.default);
        case 'th':
            return (parcelRequire("bMkyl")).then((mod)=>mod.default);
        case 'tr':
            return (parcelRequire("fIOvF")).then((mod)=>mod.default);
        case 'uk':
            return (parcelRequire("486Xk")).then((mod)=>mod.default);
        case 'vi':
            return (parcelRequire("6bLNM")).then((mod)=>mod.default);
        case 'zh_TW':
            return (parcelRequire("8jfJ9")).then((mod)=>mod.default);
        case 'zh':
            return (parcelRequire("isVNG")).then((mod)=>mod.default);
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $878ccfcc8552aaa6$export$d0a3169680473b6c(fragments[0]);
                else return (parcelRequire("gpL0n")).then((mod)=>mod.default);
            }
    }
};
module.exports["UnknownUserError"] = $878ccfcc8552aaa6$export$98e06fe7a6174253;
module.exports["NoAccessWarning"] = $878ccfcc8552aaa6$export$58bd5a2057b6b855;
module.exports["NoAccessLabel"] = $878ccfcc8552aaa6$export$da9f8ce14593162f;
module.exports["DefaultHeadline"] = $878ccfcc8552aaa6$export$4a258ffee7316766;
module.exports["DefaultAdvisedAction"] = $878ccfcc8552aaa6$export$702321a50d74536e;
module.exports["LoginAgain"] = $878ccfcc8552aaa6$export$ed7f16088a93ae9d;
module.exports["DifferentText"] = $878ccfcc8552aaa6$export$3ab158df56460d1c;
module.exports["getMessagesForLocale"] = $878ccfcc8552aaa6$export$d0a3169680473b6c;

});

parcelRegister("92AHJ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $fb7b952708721b37$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    unknownUserError: {
        id: "fabric.mention.unknow.user.error",
        defaultMessage: "Unknown user {userId}"
    },
    noAccessWarning: {
        id: "fabric.mention.noAccess.warning",
        defaultMessage: "{name} won't be notified as they have no access"
    },
    noAccessLabel: {
        id: "fabric.mention.noAccess.label",
        defaultMessage: "No access"
    },
    defaultHeadline: {
        id: "fabric.mention.error.defaultHeadline",
        defaultMessage: "Something went wrong"
    },
    defaultAdvisedAction: {
        id: "fabric.mention.error.defaultAction",
        defaultMessage: "Try again in a few seconds"
    },
    loginAgain: {
        id: "fabric.mention.error.loginAgain",
        defaultMessage: "Try logging out then in again"
    },
    differentText: {
        id: "fabric.mention.error.differentText",
        defaultMessage: "Try entering different text"
    },
    memberCountWithoutYou: {
        id: "fabric.elements.mentions.team.member.count",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}"
    },
    memberCountWithYou: {
        id: "fabric.elements.mentions.team.member.count.including.you",
        defaultMessage: "Team \u2022 {0, plural, one {1 member} other {{0} members}}, including you"
    },
    plus50MembersWithoutYou: {
        id: "fabric.elements.mentions.team.member.50plus",
        defaultMessage: "Team \u2022 50+ members"
    },
    plus50MembersWithYou: {
        id: "fabric.elements.mentions.team.member.50plus.including.you",
        defaultMessage: "Team \u2022 50+ members, including you"
    },
    xProductMentionDescription: {
        id: "fabric.elements.mentions.xproduct.mention.description",
        defaultMessage: "Needs access to Confluence"
    }
});
module.exports["messages"] = $fb7b952708721b37$export$defe85febe8b728c;

});

parcelRegister("d4YSb", function(module, exports) {

let $985ade335fa31a0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $985ade335fa31a0e$var$load("1JYrd"),
    $985ade335fa31a0e$var$load("cip6w"),
    $985ade335fa31a0e$var$load("3feYV"),
    $985ade335fa31a0e$var$load("gAG2n"),
    $985ade335fa31a0e$var$load("hFpP9"),
    $985ade335fa31a0e$var$load("cwjU2"),
    $985ade335fa31a0e$var$load("3Ff1R"),
    $985ade335fa31a0e$var$load("423Ga")
]).then(()=>parcelRequire('aIUTc'));

});

parcelRegister("2cdNr", function(module, exports) {

let $19976772e476e5d9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $19976772e476e5d9$var$load("30242"),
    $19976772e476e5d9$var$load("3qBwQ"),
    $19976772e476e5d9$var$load("7Q1SM"),
    $19976772e476e5d9$var$load("cYGDU"),
    $19976772e476e5d9$var$load("ddSTH"),
    $19976772e476e5d9$var$load("33Iaa"),
    $19976772e476e5d9$var$load("blA7x"),
    $19976772e476e5d9$var$load("gJroP")
]).then(()=>parcelRequire('aK3gp'));

});

parcelRegister("7l9dA", function(module, exports) {

let $5581a51deee4024c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $5581a51deee4024c$var$load("15aAJ"),
    $5581a51deee4024c$var$load("8rREG"),
    $5581a51deee4024c$var$load("7JdzX"),
    $5581a51deee4024c$var$load("dgXJL"),
    $5581a51deee4024c$var$load("9d8JZ"),
    $5581a51deee4024c$var$load("6681T"),
    $5581a51deee4024c$var$load("3dn3H"),
    $5581a51deee4024c$var$load("cYXvt")
]).then(()=>parcelRequire('d43Vk'));

});

parcelRegister("gpL0n", function(module, exports) {

let $bf33715bc1c03891$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf33715bc1c03891$var$load("hUbK8").then(()=>parcelRequire('6BJ6x'));

});

parcelRegister("bjfkf", function(module, exports) {

let $83bd5b66aa53de45$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $83bd5b66aa53de45$var$load("l5BBd"),
    $83bd5b66aa53de45$var$load("93ASN"),
    $83bd5b66aa53de45$var$load("24LNf"),
    $83bd5b66aa53de45$var$load("htu5t"),
    $83bd5b66aa53de45$var$load("1A450"),
    $83bd5b66aa53de45$var$load("iYQCc"),
    $83bd5b66aa53de45$var$load("nBJth")
]).then(()=>parcelRequire('9BUhf'));

});

parcelRegister("kLZmK", function(module, exports) {

let $f1f7cc6d5a6f7a03$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f1f7cc6d5a6f7a03$var$load("bbv9t"),
    $f1f7cc6d5a6f7a03$var$load("9fQoJ"),
    $f1f7cc6d5a6f7a03$var$load("cnlNg"),
    $f1f7cc6d5a6f7a03$var$load("lTboH"),
    $f1f7cc6d5a6f7a03$var$load("gBDXQ"),
    $f1f7cc6d5a6f7a03$var$load("d3Phe"),
    $f1f7cc6d5a6f7a03$var$load("lASLx"),
    $f1f7cc6d5a6f7a03$var$load("bIXgz")
]).then(()=>parcelRequire('3u3mj'));

});

parcelRegister("5a0Qd", function(module, exports) {

let $3c1e89fd267619bd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3c1e89fd267619bd$var$load("7p4je"),
    $3c1e89fd267619bd$var$load("8SZbD"),
    $3c1e89fd267619bd$var$load("9Uf61"),
    $3c1e89fd267619bd$var$load("iE05k"),
    $3c1e89fd267619bd$var$load("lv5aU"),
    $3c1e89fd267619bd$var$load("3Yk1e"),
    $3c1e89fd267619bd$var$load("5lJyy"),
    $3c1e89fd267619bd$var$load("9w9df")
]).then(()=>parcelRequire('dWF5g'));

});

parcelRegister("1KQVk", function(module, exports) {

let $147323d6e8bf4a31$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $147323d6e8bf4a31$var$load("5ZQnr"),
    $147323d6e8bf4a31$var$load("2hqQb"),
    $147323d6e8bf4a31$var$load("lJyww"),
    $147323d6e8bf4a31$var$load("gVfjY"),
    $147323d6e8bf4a31$var$load("8RVFi")
]).then(()=>parcelRequire('33aAd'));

});

parcelRegister("bqpxF", function(module, exports) {

let $8515ef876a31f490$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8515ef876a31f490$var$load("1jQRQ"),
    $8515ef876a31f490$var$load("5pOQA"),
    $8515ef876a31f490$var$load("fJSEb"),
    $8515ef876a31f490$var$load("5GSny"),
    $8515ef876a31f490$var$load("cQump"),
    $8515ef876a31f490$var$load("ajzkj"),
    $8515ef876a31f490$var$load("eyysG"),
    $8515ef876a31f490$var$load("27gvR")
]).then(()=>parcelRequire('hDeI8'));

});

parcelRegister("l7Ke1", function(module, exports) {

let $f60e1bc71727e466$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $f60e1bc71727e466$var$load("km37l"),
    $f60e1bc71727e466$var$load("gbksI"),
    $f60e1bc71727e466$var$load("9TeWr"),
    $f60e1bc71727e466$var$load("j2X7f"),
    $f60e1bc71727e466$var$load("fE8pi"),
    $f60e1bc71727e466$var$load("kUZ7k"),
    $f60e1bc71727e466$var$load("dJQL7"),
    $f60e1bc71727e466$var$load("czj6d")
]).then(()=>parcelRequire('dvQoK'));

});

parcelRegister("dGQYY", function(module, exports) {

let $9f784bcef31f77a7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9f784bcef31f77a7$var$load("lTbXI"),
    $9f784bcef31f77a7$var$load("a98cw"),
    $9f784bcef31f77a7$var$load("fOGnR"),
    $9f784bcef31f77a7$var$load("e40mE"),
    $9f784bcef31f77a7$var$load("btBGI"),
    $9f784bcef31f77a7$var$load("cDQOq"),
    $9f784bcef31f77a7$var$load("8upye"),
    $9f784bcef31f77a7$var$load("GlmUM")
]).then(()=>parcelRequire('cvpu0'));

});

parcelRegister("1lX2v", function(module, exports) {

let $0fc58c977e435e13$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0fc58c977e435e13$var$load("8wMQe").then(()=>parcelRequire('LjIsh'));

});

parcelRegister("freW0", function(module, exports) {

let $b3d4f6565dde8137$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b3d4f6565dde8137$var$load("iUyZj"),
    $b3d4f6565dde8137$var$load("4PDaO"),
    $b3d4f6565dde8137$var$load("8nEeY"),
    $b3d4f6565dde8137$var$load("lMhbw"),
    $b3d4f6565dde8137$var$load("amTTV"),
    $b3d4f6565dde8137$var$load("kLZKK"),
    $b3d4f6565dde8137$var$load("c7GMc"),
    $b3d4f6565dde8137$var$load("bnhJ1")
]).then(()=>parcelRequire('e4VAB'));

});

parcelRegister("3OPCa", function(module, exports) {

let $2c7e1436d04eac89$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $2c7e1436d04eac89$var$load("kPlMQ"),
    $2c7e1436d04eac89$var$load("ervs7"),
    $2c7e1436d04eac89$var$load("fzzMQ"),
    $2c7e1436d04eac89$var$load("8CX31"),
    $2c7e1436d04eac89$var$load("kYd4i"),
    $2c7e1436d04eac89$var$load("33S6H"),
    $2c7e1436d04eac89$var$load("kFae4"),
    $2c7e1436d04eac89$var$load("iZWpE")
]).then(()=>parcelRequire('96CT4'));

});

parcelRegister("bwEbt", function(module, exports) {

let $8641da90021f141d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $8641da90021f141d$var$load("iT2sv"),
    $8641da90021f141d$var$load("iMMtn"),
    $8641da90021f141d$var$load("3gNEO"),
    $8641da90021f141d$var$load("23VWs"),
    $8641da90021f141d$var$load("e1KaU"),
    $8641da90021f141d$var$load("93obY"),
    $8641da90021f141d$var$load("6Y9jE"),
    $8641da90021f141d$var$load("cUTaY")
]).then(()=>parcelRequire('2YvEH'));

});

parcelRegister("5at1X", function(module, exports) {

let $3c3467c741031007$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3c3467c741031007$var$load("lyPpF"),
    $3c3467c741031007$var$load("eX5n7"),
    $3c3467c741031007$var$load("gvylW"),
    $3c3467c741031007$var$load("aiYuN"),
    $3c3467c741031007$var$load("gqMCT"),
    $3c3467c741031007$var$load("bxfRe"),
    $3c3467c741031007$var$load("ed6s8"),
    $3c3467c741031007$var$load("lAuJd")
]).then(()=>parcelRequire('6VUXz'));

});

parcelRegister("eWJ7x", function(module, exports) {

let $ae197b7e6281f8e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $ae197b7e6281f8e9$var$load("iN3cj"),
    $ae197b7e6281f8e9$var$load("3nHdy"),
    $ae197b7e6281f8e9$var$load("80OLx"),
    $ae197b7e6281f8e9$var$load("gDEvm"),
    $ae197b7e6281f8e9$var$load("5MwHB"),
    $ae197b7e6281f8e9$var$load("1EVcg"),
    $ae197b7e6281f8e9$var$load("96q1k"),
    $ae197b7e6281f8e9$var$load("XQtfV")
]).then(()=>parcelRequire('4D1c2'));

});

parcelRegister("2FTTE", function(module, exports) {

let $1f2ac4fcd19f7080$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1f2ac4fcd19f7080$var$load("eC1OL"),
    $1f2ac4fcd19f7080$var$load("ilL9c"),
    $1f2ac4fcd19f7080$var$load("e4s0V"),
    $1f2ac4fcd19f7080$var$load("64nco"),
    $1f2ac4fcd19f7080$var$load("9cx6P"),
    $1f2ac4fcd19f7080$var$load("28EXy"),
    $1f2ac4fcd19f7080$var$load("7RZp5"),
    $1f2ac4fcd19f7080$var$load("leyTH")
]).then(()=>parcelRequire('htiZ2'));

});

parcelRegister("bq5Mn", function(module, exports) {

let $85069b121ab4bc4a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $85069b121ab4bc4a$var$load("4NJ49"),
    $85069b121ab4bc4a$var$load("bfOZL"),
    $85069b121ab4bc4a$var$load("4dPO1"),
    $85069b121ab4bc4a$var$load("jLbRX"),
    $85069b121ab4bc4a$var$load("5g0HW"),
    $85069b121ab4bc4a$var$load("gg8tK"),
    $85069b121ab4bc4a$var$load("eF54W"),
    $85069b121ab4bc4a$var$load("3hnPt")
]).then(()=>parcelRequire('6FDlX'));

});

parcelRegister("6paIk", function(module, exports) {

let $4a9d6374e12b3eab$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a9d6374e12b3eab$var$load("3zH5p").then(()=>parcelRequire('9VK7h'));

});

parcelRegister("I5fxG", function(module, exports) {

let $08482ea73d01879b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $08482ea73d01879b$var$load("fsCDU"),
    $08482ea73d01879b$var$load("apVmx"),
    $08482ea73d01879b$var$load("kuolm"),
    $08482ea73d01879b$var$load("fvE7S"),
    $08482ea73d01879b$var$load("5xPg2")
]).then(()=>parcelRequire('0aYYd'));

});

parcelRegister("1FesQ", function(module, exports) {

let $1364d713114d6fc2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1364d713114d6fc2$var$load("g9gkE"),
    $1364d713114d6fc2$var$load("jYdbS"),
    $1364d713114d6fc2$var$load("ltrgi"),
    $1364d713114d6fc2$var$load("6ncWv"),
    $1364d713114d6fc2$var$load("gFneG"),
    $1364d713114d6fc2$var$load("fu25G"),
    $1364d713114d6fc2$var$load("iQGcz"),
    $1364d713114d6fc2$var$load("ar4uw")
]).then(()=>parcelRequire('fHwYp'));

});

parcelRegister("cx1wp", function(module, exports) {

let $91f9bf4454da4b7f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $91f9bf4454da4b7f$var$load("dKdA9").then(()=>parcelRequire('6IGZA'));

});

parcelRegister("jK1Cf", function(module, exports) {

let $e5f391125e366c30$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $e5f391125e366c30$var$load("jhikU"),
    $e5f391125e366c30$var$load("f0i3H"),
    $e5f391125e366c30$var$load("69YlM"),
    $e5f391125e366c30$var$load("bvBAp"),
    $e5f391125e366c30$var$load("9kqmW"),
    $e5f391125e366c30$var$load("cyTsc"),
    $e5f391125e366c30$var$load("kXCsp"),
    $e5f391125e366c30$var$load("disCG")
]).then(()=>parcelRequire('cycD1'));

});

parcelRegister("bMkyl", function(module, exports) {

let $89341eca9b757efd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $89341eca9b757efd$var$load("52XP1").then(()=>parcelRequire('klwXC'));

});

parcelRegister("fIOvF", function(module, exports) {

let $b72225467f057513$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b72225467f057513$var$load("fSsz4"),
    $b72225467f057513$var$load("kWOpS"),
    $b72225467f057513$var$load("kgHzZ"),
    $b72225467f057513$var$load("9tUAi"),
    $b72225467f057513$var$load("bS9pO"),
    $b72225467f057513$var$load("j4ur8"),
    $b72225467f057513$var$load("fF7Id")
]).then(()=>parcelRequire('9kSto'));

});

parcelRegister("486Xk", function(module, exports) {

let $301d4e1521a68fed$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $301d4e1521a68fed$var$load("k3bMq").then(()=>parcelRequire('5pQz0'));

});

parcelRegister("6bLNM", function(module, exports) {

let $4818d99fabfc5b23$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4818d99fabfc5b23$var$load("lF2HI").then(()=>parcelRequire('dPXRL'));

});

parcelRegister("8jfJ9", function(module, exports) {

let $60cc4c332ad17f63$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $60cc4c332ad17f63$var$load("d91RK"),
    $60cc4c332ad17f63$var$load("f7hfJ"),
    $60cc4c332ad17f63$var$load("brdRT"),
    $60cc4c332ad17f63$var$load("QI1kr"),
    $60cc4c332ad17f63$var$load("5LvhC"),
    $60cc4c332ad17f63$var$load("lWBlc"),
    $60cc4c332ad17f63$var$load("s2EmI"),
    $60cc4c332ad17f63$var$load("jc0YL")
]).then(()=>parcelRequire('AOOMd'));

});

parcelRegister("isVNG", function(module, exports) {

let $d717ad7a14072abe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d717ad7a14072abe$var$load("708J7"),
    $d717ad7a14072abe$var$load("kVqUf"),
    $d717ad7a14072abe$var$load("j03Pa"),
    $d717ad7a14072abe$var$load("2IMxh"),
    $d717ad7a14072abe$var$load("98tcg"),
    $d717ad7a14072abe$var$load("kke1I"),
    $d717ad7a14072abe$var$load("gOwMq"),
    $d717ad7a14072abe$var$load("6GfaN")
]).then(()=>parcelRequire('gMQJr'));

});

parcelRegister("iD1Wv", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


const $70ab48cd50028ae1$var$AsyncNoAccessTooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).lazy(()=>(parcelRequire("bfi3l")).then((module)=>{
        return {
            default: module.NoAccessTooltip
        };
    }));
var $70ab48cd50028ae1$export$2e2bcd8739ae039 = $70ab48cd50028ae1$var$AsyncNoAccessTooltip;
module.exports["default"] = $70ab48cd50028ae1$export$2e2bcd8739ae039;

});

parcelRegister("bfi3l", function(module, exports) {

let $021ce3818119c131$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $021ce3818119c131$var$load("akbkC").then(()=>parcelRequire('d7Uen'));

});


//# sourceMappingURL=mention.345fa076.js.map
